import axios from 'common/AxiosAuth';
import { InquirySearchParams, InquiryListResponse, InquiryDetail, InquiryAnswerRequest } from 'types/inquiry';

// 문의 목록 검색
export const searchInquiries = async (params: InquirySearchParams): Promise<InquiryListResponse> => {
  const { page = 0, size = 10, sort = ['createdDate,desc'], ...rest } = params;

  const searchParams = new URLSearchParams();

  // 필터 파라미터
  if (rest.status) searchParams.append('status', rest.status);
  if (rest.inquiryType) searchParams.append('inquiryType', rest.inquiryType);
  if (rest.inquiryWriterType) searchParams.append('inquiryWriterType', rest.inquiryWriterType);
  if (rest.keyword) searchParams.append('keyword', rest.keyword);

  // 페이지네이션: 개별 파라미터(page, size, sort)
  searchParams.append('page', page.toString());
  searchParams.append('size', size.toString());
  (Array.isArray(sort) ? sort : [sort]).forEach((s) => searchParams.append('sort', s));

  const response = await axios.get(`/api/admin/contactUs/search?${searchParams.toString()}`);
  return response.data.data;
};

// 문의 상세 조회
export const getInquiryDetail = async (inquiryId: number): Promise<InquiryDetail> => {
  const response = await axios.get(`/api/admin/contactUs/${inquiryId}`);
  return response.data.data;
};

// 문의 답변 등록
export const answerInquiry = async (data: InquiryAnswerRequest): Promise<void> => {
  await axios.patch('/api/admin/contactUs/answer', data);
};

// 문의 상태 변경
export const updateInquiryStatus = async (inquiryId: number, status: 'PENDING' | 'COMPLETED'): Promise<void> => {
  await axios.patch(`/api/admin/contactUs/status/${inquiryId}?status=${status}`);
};

// 문의 삭제
export const deleteInquiries = async (inquiryIds: number[]): Promise<void> => {
  await axios.post('/api/admin/contactUs/delete', inquiryIds);
};
